import text from './text.json'

const translations = {text}

export default translations